import type { Bedrohung, BedrohungCreate, BedrohungUpdate } from "@iso27001/shared";
import { apiFetch } from "./client.js";

interface ListResp<T> { items: T[]; total: number; page: number; pageSize: number; }
interface AuditEntry {
  id: number; entity: string; entityId: number;
  op: "create" | "update" | "delete";
  userId: number | null; at: number;
  beforeJson: string | null; afterJson: string | null;
}

export const bedrohungenApi = {
  list: (params: { q?: string; page?: number; pageSize?: number } = {}): Promise<ListResp<Bedrohung>> => {
    const qs = new URLSearchParams();
    if (params.q) qs.set("q", params.q);
    if (params.page) qs.set("page", String(params.page));
    if (params.pageSize) qs.set("pageSize", String(params.pageSize));
    const url = `/api/bedrohungen${qs.toString() ? `?${qs}` : ""}`;
    return apiFetch<ListResp<Bedrohung>>(url);
  },
  get: (id: number): Promise<Bedrohung> => apiFetch<Bedrohung>(`/api/bedrohungen/${id}`),
  create: (body: BedrohungCreate): Promise<Bedrohung> =>
    apiFetch<Bedrohung>("/api/bedrohungen", { method: "POST", body: JSON.stringify(body) }),
  update: (id: number, body: BedrohungUpdate): Promise<Bedrohung> =>
    apiFetch<Bedrohung>(`/api/bedrohungen/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  remove: (id: number): Promise<null> =>
    apiFetch<null>(`/api/bedrohungen/${id}`, { method: "DELETE" }),
  audit: (id: number): Promise<{ items: AuditEntry[] }> =>
    apiFetch<{ items: AuditEntry[] }>(`/api/bedrohungen/${id}/audit`),
};
